import { isTryOnMobile, loadScriptOnIntent } from "../../../scripts/utils/utils";

const fitmixTryOnContainer = document.getElementById("fitmix-container");
const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const firstGlasses = tryonTemplateContainer?.querySelector('.to-glasses-wrapper[data-frame-id]');
let frameIdTryOn = firstGlasses?.dataset?.frameId;

// Early exit if try-on feature is not present on this page
if (!fitmixTryOnContainer || !frameIdTryOn) return;

const langTryOn = tryonTemplateContainer?.dataset?.lang;

let paramsTryOn = {
  apiKey: 'FKKyiL0aNESWKAlx1UDeYGlJY6Yw6RQ2o7J7pjXt',
  lang: langTryOn ? langTryOn : 'en',
  liveAutostart: true,
  mode: "live",
  frame: frameIdTryOn,
  watermark: false,
  uiConfiguration: {
    liveRelaunchDetectionButton: false,
    livePhotoButton: false
  },
  onPrivacyTermsShown: () => tryonTemplateContainer?.classList.add('disclaimer-shown'),
  onAgreePrivacyTerms: () => tryonTemplateContainer?.classList.remove('disclaimer-shown'),
  onDisagreePrivacyTerms: () => tryonTemplateContainer?.classList.remove('disclaimer-shown'),
  css: `
    #vtoAdvDisclaimer { justify-content: center; align-content: baseline;}
    #vtoAdvDisclaimerShortTerms { font-size: 13px; margin-top: 37px; }
    #vtoAdvDisclaimerTerms { 
      ${!window.tryOnDisclaimerLongText ? 'display: none;' : ''}
      ${window.tryOnDisclaimerActivateLong ? 'visibility: hidden;' : ''}
      font-size: 14px; 
    }
    #vtoAdvDisclaimerTerms::after {
      display: block;
      visibility: visible;
      margin-top: -25px;
      content: "${window.tryOnDisclaimerActivateLong}";
    }

    [ng-if="isPrivacyPolicyShown"] { height: 60vh; margin-top: 10px; }
  `,
};

if (
  window.tryOnDisclaimerShortText ||
  window.tryOnDisclaimerLongText ||
  window.tryOnDisclaimerAgreeButton ||
  window.tryOnDisclaimerDisagreeButton
) {
  paramsTryOn.dataPrivacyDisclaimerTexts = {};
}

if (window.tryOnDisclaimerShortText) {
  paramsTryOn.dataPrivacyDisclaimerTexts.shortText = tryOnDisclaimerShortText;
}
if (window.tryOnDisclaimerShortText) {
  paramsTryOn.dataPrivacyDisclaimerTexts.longText = tryOnDisclaimerLongText;
}
if (window.tryOnDisclaimerAgreeButton) {
  paramsTryOn.dataPrivacyDisclaimerTexts.agreeButton = tryOnDisclaimerAgreeButton;
}
if (window.tryOnDisclaimerDisagreeButton) {
  paramsTryOn.dataPrivacyDisclaimerTexts.disagreeButton = tryOnDisclaimerDisagreeButton;
}

async function initFitMix() {
  try {
    await loadScriptOnIntent(
      'https://vto-advanced-integration-api.fittingbox.com/index.js',
      fitmixTryOnContainer,
      {
        mobile: 'viewport',
        desktop: 'hover',
        idleTimeout: 5000,
        checkGlobal: 'FitMix',
        sessionKey: 'fitmix_interaction'
      }
    );

    fitmixInstance = FitMix.createWidget('fitmix-container', paramsTryOn, onFitMixReady);
  } catch (error) {
  }
}

function onFitMixReady() {
  openVto();
}

function openVto() {
  sessionStorage.setItem('fitmix_interaction', 'true');
  fitmixInstance.startVto('live');
  fitmixTryOnContainer.style.display = 'block';
}

function initGlassesEvents() {
  const allGlasses = tryonTemplateContainer?.querySelectorAll('.to-glasses-wrapper[data-frame-id]');
  const allConnectedProducts = tryonTemplateContainer?.querySelectorAll('.to-connected-product[data-frame-id]');

  setChangeFrameEvents(allGlasses, false);
  setChangeFrameEvents(allConnectedProducts, true);
}

function setChangeFrameEvents(frames, showOnMobile = true) {
  frames.forEach(frame => {
    const frameId = frame.dataset?.frameId;
    if (!frameId) return;

    frame.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!(isTryOnMobile() && !showOnMobile)) handleSelection(frame);
    });
  });
}
function setFrame(targetEl) {
  if (targetEl.classList.contains('to-connected-product')) {
    handleSelection(targetEl);
  } else {
    const targetElIsWrapper = targetEl.classList.contains('to-glasses-wrapper');
    const glassesWrapper = targetElIsWrapper ? targetEl : targetEl.closest('.to-glasses-wrapper');
    const tempSelFrame = glassesWrapper.querySelector('.to-connected-product:not(.to-cp-not-available)');
    if (tempSelFrame) handleSelection(tempSelFrame);
  }
}

function handleSelection(newSelectedFrame) {
  if (newSelectedFrame.classList.contains('to-cp-not-available')) return;

  const oldSelectedFrame = tryonTemplateContainer?.querySelector('.selected-frame');
  const isWrapper = newSelectedFrame.classList.contains('to-glasses-wrapper');
  if (oldSelectedFrame) oldSelectedFrame?.classList.remove('selected-frame');
  if (isWrapper) newSelectedFrame = newSelectedFrame.querySelector('.to-default-cp');
  newSelectedFrame?.classList.add('selected-frame');

  const frameSelectedEvent = new CustomEvent('try-on:frame-selected');
  setTimeout(document.dispatchEvent(frameSelectedEvent));

  const frameId = newSelectedFrame.dataset.frameId;
  fitmixInstance?.setFrame(frameId);
}

function selectInitialFrame() {
  let selectInitialFrame;

  if (isTryOnMobile()) {
    selectInitialFrame = tryonTemplateContainer?.querySelector('.to-connected-product.is-selected:not(.to-cp-not-available');
  } else {
    selectInitialFrame = tryonTemplateContainer?.querySelector('.to-connected-product:not(.to-cp-not-available');
  }

  if (!selectInitialFrame) return;
  handleSelection(selectInitialFrame);
}

// Initialize FitMix with intent-based loading
initFitMix();

setTimeout(selectInitialFrame);
initGlassesEvents();

document.addEventListener('try-on:loaded-glasses', () => setTimeout(initGlassesEvents));
document.addEventListener('try-on:frame-changed', (e) => {
  const selectedGlasses = e.detail.selectedGlasses;
  if (selectedGlasses) setFrame(selectedGlasses);
});

